import React from "react";
import styles from "./SectionWrapper.module.css";

const SectionWrapper = ({ title, headerRight, children, className = "" }) => {
  return (
    <section className={`${styles.section} ${className}`.trim()}>
      <div className={styles.headerRow}>
        <div className={styles.header}>{title}</div>
        {headerRight && <div className={styles.headerControls}>{headerRight}</div>}
      </div>
      <div className={styles.divider} />
      {children}
    </section>
  );
};

export default SectionWrapper;
